

































































import Vue from 'vue';
import CustomerProp, { PropType } from '../../models/CustomerProp';
import AddCustomerField from './AddCustomerField.vue';
import customerClient from '../../apis';

export default Vue.extend({
  components: {
    AddCustomerField,
  },
  props: {
    prop: Object,
    splitIndexes: Array,
    editable: Boolean,
    index: Number,
  },
  computed: {
    isSplitKey(): boolean {
      return (this.splitIndexes as any).includes(this.index);
    },
  },
  data() {
    return {
      showEditBox: false,
      showDeleteBox: false,
      PropType,
    };
  },
  methods: {
    deleteConfirm() {
      const fieldName = this.$props.prop.fieldName;
      customerClient.deleteProp({
        propField: fieldName,
      }).success(r => {
        this.$Message.success('删除成功');
        this.$data.showDeleteBox = false;
        this.$store.commit('DELETE_CUSTOMER_PROP', fieldName);
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
});
